import './AvatarComponent.sass';

import { BridgeWarAvatar } from '../../assets/bridgewars/avatars';
import { bridgeWarAssets } from '../../assets/bridgewars';
import React, { CSSProperties } from 'react';

type AvatarComponentProps = {
    avatar: BridgeWarAvatar;
    head?: boolean;
};

//console.log('bridgeWarAssets', bridgeWarAssets);

export const AvatarComponent: React.FC<AvatarComponentProps> = ({ avatar, head = false }) => {
    const { lvl, color, figurine } = avatar;
    const figurineUrl = lvl[0][0];
    const headUrl = lvl[0][1];
    if ((!head && !figurineUrl) || (head && !headUrl)) {
        return null;
    }
    const styles: CSSProperties = {
        '--avatarColor': color,
    } as CSSProperties;
    return (
        <section className={`AvatarComponent ${figurine} ${head ? 'head' : 'figurine'}`} style={styles}>
            {head ? (
                <>
                    <img src={headUrl} alt={avatar.figurine} />
                </>
            ) : (
                <>
                    <div className="background" />
                    <img src={figurineUrl} alt={avatar.figurine} />
                </>
            )}
        </section>
    );
};
